"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var gridCheck = function gridCheck(allGrids) {
  var initialCheckedGrids = [];
  var gridIndex = 0;

  var _iterator = _createForOfIteratorHelper(allGrids),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var initGrid = _step.value;
      var newGridObject = {
        rect: _objectSpread(_objectSpread({}, initGrid.rect), {}, {
          id: "rect".concat(gridIndex)
        }),
        vLines: [],
        hLines: [],
        x1: null,
        x2: null,
        y1: null,
        y2: null,
        processing_status: [],
        page_number: null
      };

      if (initGrid.hasOwnProperty("warning")) {
        newGridObject["warning"] = initGrid["warning"];
      }

      if (initGrid.hasOwnProperty("processing_status")) {
        newGridObject["processing_status"] = initGrid["processing_status"];
      }

      if (initGrid.hasOwnProperty("page_number")) {
        newGridObject["page_number"] = initGrid["page_number"];
      }

      if (initGrid.hasOwnProperty("x1")) {
        newGridObject["x1"] = initGrid["x1"];
      }

      if (initGrid.hasOwnProperty("x2")) {
        newGridObject["x2"] = initGrid["x2"];
      }

      if (initGrid.hasOwnProperty("y1")) {
        newGridObject["y1"] = initGrid["y1"];
      }

      if (initGrid.hasOwnProperty("y2")) {
        newGridObject["y2"] = initGrid["y2"];
      }

      var vLineIndex = 0;

      var _iterator2 = _createForOfIteratorHelper(initGrid.vLines),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var initVLine = _step2.value;

          if (initGrid.rect.x <= initVLine.x && initVLine.x <= initGrid.rect.x + initGrid.rect.width) {
            newGridObject.vLines.push(_objectSpread(_objectSpread({}, initGrid.vLines[vLineIndex]), {}, {
              xRectDist: initGrid.vLines[vLineIndex].x - initGrid.rect.x,
              id: "vLine".concat(vLineIndex, "init").concat(newGridObject.rect.id)
            }));
          } else {
            console.warn("Vertical line with x position ".concat(initVLine.x, " is not contained within the rectangle ").concat(newGridObject.rect.id, ". Bounds: (").concat(initGrid.rect.x, ",").concat(initGrid.rect.x + initGrid.rect.width, ")"));
          }

          vLineIndex = vLineIndex + 1;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var hLineIndex = 0;

      var _iterator3 = _createForOfIteratorHelper(initGrid.hLines),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var initHLine = _step3.value;

          if (initGrid.rect.y <= initHLine.y && initHLine.y <= initGrid.rect.y + initGrid.rect.height) {
            newGridObject.hLines.push(_objectSpread(_objectSpread({}, initGrid.hLines[hLineIndex]), {}, {
              yRectDist: initGrid.hLines[hLineIndex].y - initGrid.rect.y,
              id: "hLine".concat(hLineIndex, "init").concat(newGridObject.rect.id)
            }));
          } else {
            console.warn("Horizontal line with y position ".concat(initHLine.y, " is not contained within the rectangle ").concat(newGridObject.rect.id, ". Bounds: (").concat(initGrid.rect.y, ",").concat(initGrid.rect.y + initGrid.rect.height, ")"));
          }

          hLineIndex = hLineIndex + 1;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      initialCheckedGrids.push(newGridObject);
      gridIndex = gridIndex + 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return initialCheckedGrids;
};

var _default = gridCheck;
exports.default = _default;